import cookie from '../../util/cookie';
import config from '../../util/config';
import util from '../../util';

class CallbackFn {
	constructor(pagefromUrl, deliveryCode, resumeId, $v5, deliveryMsg, deliveryState) {
		this.pagefromUrl = pagefromUrl;
		this.deliveryCode = deliveryCode;
		this.deliveryMsg = deliveryMsg;
		this.deliveryState = deliveryState;
		this.resumeId = resumeId;
		this.$v5 = $v5;
		this.fromType = util.getParamVal('formType');
		this.deliverySource = util.getParamVal('deliverySource');
		this.backType = util.getParamVal('backType');
	}
	// 来源教育经历
	fromEducation() {
		let successUrl = '';
		if (this.pagefromUrl.indexOf('?') !== -1) {
			successUrl =
				this.pagefromUrl + '&deliveryCode=' + this.deliveryCode;
		} else {
			successUrl =
				this.pagefromUrl + '?deliveryCode=' + this.deliveryCode;
		}
		window.location.replace(successUrl);
	}

	// 微信小程序处理
	fromWX() {
		let ppu = encodeURIComponent(cookie.get('PPU'));
		let successUrl = '';
		if (this.pagefromUrl.indexOf('?') > -1) {
			successUrl = `${this.pagefromUrl}&deliveryCode=${this.deliveryCode}&ppu=${ppu}`;
		} else {
			successUrl = `${this.pagefromUrl}?deliveryCode=${this.deliveryCode}&ppu=${ppu}`;
		}
		let message = '';
		if (util.getParamVal('infoids')) {
			message = this.deliveryState ?  '简历创建并投递成功' : (this.deliveryMsg || '网络异常，请稍后重试');
		} else {
			message = '简历创建成功';
		}
		this.$v5.toast(message).then(() => {
			switch(this.fromType) {
				// 微信小程序 tabbar 页面跳转
				case 'weapp-tabBar': {
					window.wx.miniProgram.switchTab({
						url: successUrl
					});
					break;
				}
				default: {
					//navigateTo 打开简历创建页面，返回时通过 navigateBack 回到打开前的页面后，通过 redirectTo 替换页面栈（目前应用于：58本地招工回跳）
					if(this.backType === '1') {
						window.wx.miniProgram.navigateBack({
							delta: 1,
							complete: () => {
								window.wx.miniProgram.redirectTo({
									url: successUrl
								});
							}
						});
					} else {
						window.wx.miniProgram.redirectTo({
							url: successUrl
						});
					}
				}
			}
		});
	}

	// 百度小程序处理
	fromBD() {
		// 百度小程序跳转
		this.$v5.toast('简历创建并投递成功').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU'));
			window.swan.webView.redirectTo({
				url: `${this.pagefromUrl}&deliveryCode=${
					this.deliveryCode
					}&ppu=${ppu}`
			});
		});
	}

	// 支付宝小程序处理
	fromZFB() {
		// 支付宝小程序跳转
		this.$v5.toast('简历创建并投递成功').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU'));
			window.my.redirectTo({
				url: `${this.pagefromUrl}&deliveryCode=${
					this.deliveryCode
					}&ppu=${ppu}`
			});
		});
	}

	// 头条小程序
	fromTT() {
		// 头条小程序跳转
		this.$v5.toast('简历创建并投递成功').then(() => {
			let ppu = encodeURIComponent(cookie.get('PPU'));
			window.tt.miniProgram.redirectTo({
				url: `${this.pagefromUrl}&deliveryCode=${
					this.deliveryCode
					}&ppu=${ppu}`
			});
		});
	}

	// 同镇
	fromTZ() {
		this.$v5.toast('简历创建并投递成功').then(() => {
			WBAPP.action.goback(true);
		});
	}
	// 校招
	fromXZ() {
		this.$v5.toast('简历创建成功').then(() => {
			window.location.replace(this.pagefromUrl);
		});
	}
	fromCQXZ() {
		this.$v5.toast('简历创建成功').then(() => {
			window.location.replace(this.pagefromUrl);
		});
	}

	// default
	default() {
		//如果from参数不为空，则跳转指定落地页
		if (!!this.pagefromUrl) {
			this.$v5.toast('简历创建成功').then(() => {
				window.location.replace(this.pagefromUrl);
			});
			return;
		}
		window.location.replace(
			config.jlDomain +
			'/resumeupdate/perfectresume?rid=' +
			this.resumeId +
			'&authType=1'
		);
	}
}

export {
	CallbackFn
};



// WEBPACK FOOTER //
// ./src/module/basic/components/expectation/CallbackFn.js